export const getHost = (url) => {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}

export const buildUrlIssue = (projectKey, issueKey, provider = 'jira') => {
  if (!projectKey || !issueKey) return null;
  switch (provider.toLowerCase()) {
    case 'jira':
      return `https://globe-sav.atlassian.net/jira/servicedesk/projects/${projectKey}/queues/issue/${issueKey}`;
    default:
      return null;
  }
}

// Jira URL of an issue — empty for CSV-sourced rows (no Jira ticket) or incomplete keys.
export const issueHref = (row) =>
  (row?.source === 'CSV' ? '' : buildUrlIssue(row?.project_key, row?.issue_key)) || '';
